import './news.scss';


// SHARE BTN
//==================================================================================================================
$('a.bt').click(function () {
  var url = $(this).attr('href');
  var winpar = 'width=500,height=400,left=' + ((window.innerWidth - 500) / 2) + ',top=' + ((window.innerHeight - 400) / 2);
  window.open(url, 'tvkw', winpar);
  return false;
});
